export default __webpack_public_path__ + "static/media/cover.ddb35a49.jpg";